import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Packages from './components/Packages';
import IndividualTests from './components/IndividualTests';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import Privacypolicy from './components/Privacypolicy';
import Termsofuse from './components/Termsofuse';
import Cookiepolicy from './components/Cookiepolicy';
// الصفحة الرئيسية: كل الأقسام زي ما هي دلوقتي (سكرول واحد طويل)
const HomePage = () => (
  <>
    <Hero />
    <IndividualTests />
    <Services />
    <About />
    <Packages />
    <Contact />
  </>
);
function App() {
  return (
    <BrowserRouter>
      <div dir="rtl" lang="ar">
        {/* الهيدر والفوتر والشات بوت ثابتين في كل الصفحات */}
        <ScrollToTopOnRouteChange />
        <ScrollToTopButton />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/terms-of-use" element={<Termsofuse />} />
          <Route path="/cookie-policy" element={<Cookiepolicy />} />
        </Routes>
        <Footer />
        <Chatbot />
      </div>
    </BrowserRouter>
  );
}
export default App;
